export default __webpack_public_path__ + "static/media/Illustration2.fc942025.svg";